/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import StandardProperties from '../../input-properties.mdx';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    code: "code",
    em: "em"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Properties"
    }), "\n", _jsx(StandardProperties, {
      type: "number | string"
    }), "\n", _jsx(_components.h3, {
      children: "Component-specific props"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Property"
          }), _jsx(_components.th, {
            children: "Type"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "variant"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "string"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Choice of UI feature. Can be: ", _jsx(_components.code, {
              children: "dropdown"
            }), ", ", _jsx(_components.code, {
              children: "radio"
            }), " or ", _jsx(_components.code, {
              children: "checkbox"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "width"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "string"
            }), " or ", _jsx(_components.code, {
              children: "false"
            })]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " ", _jsx(_components.code, {
              children: "false"
            }), " for no width (use browser default), ", _jsx(_components.code, {
              children: "medium"
            }), " or ", _jsx(_components.code, {
              children: "large"
            }), " for predefined standard widths, ", _jsx(_components.code, {
              children: "stretch"
            }), " for fill available width."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "children"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "React.Node"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " For providing Option components"]
          })]
        })]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
